// Central API base resolver.
//
// On the preview / dev environment we want to call the explicit
// REACT_APP_BACKEND_URL (because the frontend is served separately from the
// backend). On the deployed production domain (assendaph.com) we call the API
// same-origin — `https://assendaph.com/api/*` is proxied to the backend, and
// same-origin calls are not flagged by Cloudflare's bot / challenge layer,
// which was intermittently returning 403 to cross-origin XHRs.
//
// Heuristic: if the browser is running on any emergent.host / emergentagent
// subdomain or on localhost, trust REACT_APP_BACKEND_URL. Otherwise (custom
// production domain like assendaph.com), use the current origin.

const PREVIEW_HOST_MATCH = /(emergentagent\.com|emergent\.host|localhost|127\.0\.0\.1)/i;

const resolveBase = () => {
  const envUrl = process.env.REACT_APP_BACKEND_URL;
  if (typeof window === "undefined") return envUrl;
  const host = window.location.hostname || "";
  if (PREVIEW_HOST_MATCH.test(host)) return envUrl;
  return window.location.origin;
};

export const BACKEND_URL = resolveBase();
export const API = `${BACKEND_URL}/api`;
